"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTION_OPTIONS_TX_GUARDED = exports.TRANSACTION_OPTIONS_TX_HASH_SIGN = exports.TRANSACTION_VERSION_WITH_OPTIONS = exports.LEDGER_TX_GUARDIAN_MIN_VERSION = exports.LEDGER_TX_HASH_SIGN_MIN_VERSION = void 0;
// Since this version, the MultiversX Ledger App only supports signing a hash of the transaction - tx.options = 0b0001.
exports.LEDGER_TX_HASH_SIGN_MIN_VERSION = "1.0.11";
// Since this version, the MultiversX Ledger App supports guarded transactions - tx.options = 0b00(0|1)1.
exports.LEDGER_TX_GUARDIAN_MIN_VERSION = "1.0.22";
exports.TRANSACTION_VERSION_WITH_OPTIONS = 2;
exports.TRANSACTION_OPTIONS_TX_HASH_SIGN = 0b0001;
exports.TRANSACTION_OPTIONS_TX_GUARDED = 0b0010;
//# sourceMappingURL=constants.js.map